import React from 'react'
import { getImages } from './const'

const HeaderActions = ({ wrapperRef, hoverHandleSubMenu, openSubMenu, handleSubMenu }) => {
    return (
        <>
            <div className='d-flex ps-3 d-xl-none align-items-center'>
                <button type='button' className={`me-3 transparent-btn hd-ab-btn hc-icon position-relative mm-hc-icon ${openSubMenu === 'clock' ? 'active' : ''}`}
                    onClick={() => handleSubMenu('clock')}
                >
                    <span className='time-icon'></span>
                </button>
                <button type='button' className={`me-3 transparent-btn hd-ab-btn hc-icon position-relative mm-hc-icon ${openSubMenu === 'phone' ? 'active' : ''}`}
                    onClick={() => handleSubMenu('phone')}
                >
                    <span className='local-phone-icon'></span>
                </button>
                <button type='button' className={`me-3 transparent-btn hd-ab-btn hc-icon position-relative mm-hc-icon ${openSubMenu === 'location' ? 'active' : ''}`}
                    onClick={() => handleSubMenu('location')}
                >
                    <span className='location-pin-icon'></span>
                </button>
            </div>
            <div ref={wrapperRef} className={`me-xl-3 hb-block ${openSubMenu === 'clock' ? 'active' : ''}`}
                // onClick={() => handleSubMenu('clock')}
                onMouseEnter={() => hoverHandleSubMenu('clock')}
                onMouseLeave={() => hoverHandleSubMenu(null)}
            >
                <button type='button' className='d-none d-xl-block transparent-btn hd-ab-btn hc-icon position-relative'>
                    <span className='time-icon'></span>
                </button>
                <div className='actions-dropdown w-740'>
                    <div className='row gx-xl-5 gx-0'>
                        <div className='col-xl-6'>
                            <div className='d-flex align-items-center mb-xl-4 mb-2'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>Tampa, FL</div>
                            </div>
                            <div className='mnw-300 xs-title'>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Monday - Friday</div>
                                    <div className='col-6 avenir-next fw-500'>9am - 6pm</div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Saturday</div>
                                    <div className='col-6 avenir-next fw-500'>10am - 4pm</div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Sunday</div>
                                    <div className='col-6 avenir-next fw-500'>Closed</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6'>
                            <div className='d-flex align-items-center mb-xl-4 mb-2'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>San Clemente, CA</div>
                            </div>
                            <div className='mnw-300 xs-title'>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Monday - Friday</div>
                                    <div className='col-6 avenir-next fw-500'>9am - 6pm</div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Saturday</div>
                                    <div className='col-6 avenir-next fw-500'>10am - 4pm</div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-6 avenir-next opacity-0-5'>Sunday</div>
                                    <div className='col-6 avenir-next fw-500'>Closed</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={wrapperRef} className={`me-xl-3 hb-block ${openSubMenu === 'phone' ? 'active' : ''}`}
                // onClick={() => handleSubMenu('phone')}
                onMouseEnter={() => hoverHandleSubMenu('phone')}
                onMouseLeave={() => hoverHandleSubMenu(null)}
            >
                <button type='button' className='d-none d-xl-block transparent-btn hd-ab-btn hc-icon position-relative'>
                    <span className='local-phone-icon'></span>
                </button>
                <div className='actions-dropdown w-740'>
                    <div className='row gx-xl-5 gx-0'>
                        <div className='col-xl-6'>
                            <div className='d-flex align-items-center mb-xl-4 mb-2'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>Tampa, FL</div>
                            </div>
                            <div className='mnw-300 xs-title'>
                                <div className='row mb-3'>
                                    <div className='col-5 avenir-next opacity-0-5'>Sales</div>
                                    <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> (813) 578-4192</div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-5 avenir-next opacity-0-5'>Service</div>
                                    <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> (813) 592-7722</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6'>
                            <div className='d-flex align-items-center mb-xl-4 mb-2'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>San Clemente, CA</div>
                            </div>
                            <div className='mnw-300 xs-title'>
                                <div className='row mb-3'>
                                    <div className='col-5 avenir-next opacity-0-5'>Sales</div>
                                    <div className='col-7 avenir-next fw-500'><img style={{ maxWidth: '17px' }} className='me-1' src={getImages('local-phone-hover.png')} /> (949) 273-1100</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={wrapperRef} className={`me-xl-3 hb-block ${openSubMenu === 'location' ? 'active' : ''}`}
                // onClick={() => handleSubMenu('location')}
                onMouseEnter={() => hoverHandleSubMenu('location')}
                onMouseLeave={() => hoverHandleSubMenu(null)}
            >
                <button type='button' className='d-none d-xl-block transparent-btn hd-ab-btn hc-icon position-relative'>
                    <span className='location-pin-icon'></span>
                </button>
                <div className='actions-dropdown w-740'>
                    <div className='row gx-xl-5 gx-0'>
                        <div className='col-xl-6 pe-xl-5'>
                            <div className='d-flex align-items-center'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>Tampa, FL</div>
                            </div>
                            <div className='xs-title font-13 mt-2 mb-3'>7817 N Dale Mabry Hwy <br />Tampa, FL 33614</div>
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.1658352195077!2d-82.5044729!3d28.019406800000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e50bf9dc0def%3A0x1641769292fc877f!2sEuropean%20Exotic%20Center!5e0!3m2!1sen!2sin!4v1758121637702!5m2!1sen!2sin" width="100%" height="127" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
                            <iframe src="https://snazzymaps.com/embed/739247" width="100%" height="127px" style={{border:'none'}}></iframe>
                            <div>
                                <a href="https://maps.app.goo.gl/8opCErm85YUk63Bj9" target="_blank" className='xs-title font-13 text-orange fw-500 avenir-next d-inline-block'>Get Directions</a>
                            </div>
                        </div>
                        <div className='col-xl-6 ps-xl-5'>
                            <div className='d-flex align-items-center'>
                                <div className='me-xl-3 me-2'>
                                    <img className='location-icon' src={getImages('location-icon.png')} alt='location' />
                                </div>
                                <div className='md-title'>San Clemente, CA</div>
                            </div>
                            <div className='xs-title font-13 mt-2 mb-3'>101 W Avenida Vista Hermosa Ste 464 <br />San Clemente , CA 92672</div>
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.3283306180465!2d-117.6291397!3d33.4407515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcf3038246be97%3A0xdc614b57d6def33e!2sEuropean%20Exotic%20Center!5e0!3m2!1sen!2sin!4v1758121907415!5m2!1sen!2sin" width="100%" height="127" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
                            <iframe src="https://snazzymaps.com/embed/739251" width="100%" height="127px" style={{border:'none'}}></iframe>
                            <div>
                                <a href="https://maps.app.goo.gl/KAV1PEzJXLbZAp8a8" target="_blank" className='xs-title font-13 text-orange fw-500 avenir-next d-inline-block'>Get Directions</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HeaderActions